import PropTypes from 'prop-types'
import './FormTitleRow.scss'


export default function FormTitleChip({chip, className, ...props}) {
  return (
    <span className={`form-title-chip rounded-circle ${className}`} {...props}> {chip} </span>
  )
}

FormTitleChip.propTypes = {
  chip: PropTypes.any,
  className: PropTypes.string,
}
